<template>
    <kgr-form-scaffold
        :pending="pending"
        :with-primary-buttons="false"
        @backBtnClicked="redirectToOverview"
    >
        <kgr-employee-knowledge-data-provider
            :employee-id="employeeId"
            :callback="onEmployeeKnowledgeLoaded"
        >
            <div>
                <kgr-employee-knowledge-form
                    :employee-knowledge="employeeKnowledge"
                    :error="knowledgeError"
                    @enter="updateKnowledge"
                />
            </div>
        </kgr-employee-knowledge-data-provider>

        <kgr-employee-spoken-languages-data-provider
            v-slot="languageScope"
            :employee-id="employeeId"
            :callback="onEmployeeSpokenLanguagesLoaded"
        >
            <kgr-employee-spoken-languages-form
                :spoken-languages="spokenLanguages"
                :employee-id="employeeId"
                @updated="onUpdate(languageScope.reload)"
            />
        </kgr-employee-spoken-languages-data-provider>
    </kgr-form-scaffold>
</template>

<script>
import EmployeeKnowledgeDataProvider from '../../components/data-provider/EmployeeKnowledgeDataProvider.vue';
import EmployeeKnowledgeForm from '../../components/employees/EmployeeKnowledgeForm.vue';
import EmployeeRepository from '../../js/repository/EmployeeRepository';
import EmployeeSpokenLanguagesDataProvider from '../../components/data-provider/EmployeeSpokenLanguagesDataProvider.vue';
import Error from '../../js/model/Error';
import FormScaffold from '../../components/common/form/FormScaffold.vue';
import SpokenLanguagesForm from '../../components/employees/spoken-languages/SpokenLanguagesForm.vue';

export default {
    name: 'EmployeeKnowledge',
    components: {
        'kgr-form-scaffold': FormScaffold,
        'kgr-employee-knowledge-data-provider': EmployeeKnowledgeDataProvider,
        'kgr-employee-knowledge-form': EmployeeKnowledgeForm,
        'kgr-employee-spoken-languages-data-provider': EmployeeSpokenLanguagesDataProvider,
        'kgr-employee-spoken-languages-form': SpokenLanguagesForm,
    },
    props: {
        overviewUrl: {
            type: String,
            required: true,
        },
        employeeId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            pending: false,
            knowledgeError: new Error(),
            employeeKnowledge: null,
            spokenLanguages: [],
        };
    },
    methods: {
        redirectToOverview() {
            window.location = this.overviewUrl;
        },
        updateKnowledge() {
            this.pending = true;
            EmployeeRepository.updateKnowledge(this.employeeId, this.employeeKnowledge)
                .then(() => {
                    this.$notify.success('saveChanges.success');
                    this.pending = false;
                })
                .catch((error) => {
                    this.knowledgeError = error;
                    this.$notify.error('saveChanges.error');
                    this.pending = false;
                });
        },
        onEmployeeKnowledgeLoaded(loadedEmployeeKnowledge) {
            this.employeeKnowledge = loadedEmployeeKnowledge;
        },
        onEmployeeSpokenLanguagesLoaded(loadedSpokenLanguages) {
            this.spokenLanguages = loadedSpokenLanguages;
        },
        onUpdate(reload) {
            reload();
        },
    },
};
</script>

<style scoped>

</style>
